"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormulaService = void 0;
// TODO: upgrade to this package: https://github.com/handsontable/hyperformula/
const hot_formula_parser_1 = require("hot-formula-parser");
const moment_1 = __importDefault(require("moment"));
const date_utils_1 = require("../../utils/date-utils");
class FormulaService {
    /**
     * Parse a formula with variables - eg. `A1 * B1 + (C1 / 2)`
     * @param formula formula string
     * @param rows array of values
     */
    parseRows(formula, rows, formulaRowNumber = 1) {
        const parser = new hot_formula_parser_1.Parser();
        this.addParserHooks(parser, rows, formulaRowNumber);
        const formulaCleaned = formula && formula.trimLeft().startsWith('=') ? formula.substr(formula.indexOf('=') + 1) : formula;
        const { result, error } = parser.parse(formulaCleaned);
        return { result: this.formatResult(result), error: this.formatError(error) };
    }
    /**
     * Parse a formula with embedded values - eg. `10 * 5 + (6 / 2)`
     */
    parse(formula) {
        return this.parseRows(formula, [], 1);
    }
    hoursDiff(timeStart, timeEnd) {
        // only return a result when both values exist
        if (!timeStart || !timeEnd) {
            return { result: '0' };
        }
        const start = (0, moment_1.default)(this.parseTime(timeStart));
        const end = (0, moment_1.default)(this.parseTime(timeEnd));
        // eg. shift starts at 8pm ends at 4am
        if (start > end) {
            start.subtract(1, 'day');
        }
        const hours = (0, moment_1.default)(end).diff(start, 'hours', true);
        return { result: Math.abs(hours).toFixed(2) };
    }
    daysDiff(timeStart, timeEnd) {
        // only return a result when both values exist
        if (!timeStart || !timeEnd) {
            return { result: '0' };
        }
        const start = (0, moment_1.default)(this.parseTime(timeStart));
        const end = (0, moment_1.default)(this.parseTime(timeEnd));
        const days = (0, moment_1.default)(end).diff(start, 'days', true);
        return { result: Math.abs(days).toFixed(0) };
    }
    addParserHooks(parser, rows, formulaRowNumber) {
        parser.on('callCellValue', (cell, done) => {
            // adjust the row index relative to formulaRowNumber - as formulas are relative
            // to the whole template, but rows are only relative to the current table
            // eg. formula=A5*10, if formulaRowNumber=5, then A5 should be A1 for this table
            const rowIndex = cell.row.index - formulaRowNumber + 1; // rows are 1 based, index is 0 based
            const colIndex = cell.column.index;
            if (rows && rowIndex >= 0 && rowIndex < rows.length) {
                if (colIndex < rows[rowIndex].columns.length) {
                    if (rows[rowIndex].columns[colIndex]) {
                        const { value } = rows[rowIndex].columns[colIndex];
                        // either return the input value or return 0 to indicate this cell exists, just doesn't have a value in it yet
                        done(this.parseValue(value));
                    }
                }
                else {
                    throw Error('#VALUE!');
                }
            }
            else {
                throw Error('#VALUE!');
            }
        });
        parser.on('callFunction', (name, params, done) => {
            if (name.toUpperCase() === 'TIMEDIF' && params.length > 1) {
                const { result } = this.hoursDiff(params[0], params[1]);
                done(result);
            }
            else if (name.toUpperCase() === 'DATEDIF' && params.length > 1) {
                const { result } = this.daysDiff(params[0], params[1]);
                done(result);
            }
        });
    }
    parseValue(value) {
        const numberValue = Number(value);
        return Number.isFinite(numberValue) ? numberValue : value || 0;
    }
    parseTime(time) {
        return time || date_utils_1.DateUtil.convertTimeToUTCString({ hour: 0, minute: 0, second: 0 });
    }
    formatResult(result) {
        if (result === null) {
            return '';
        }
        if (typeof result === 'number') {
            return result.toFixed(2);
        }
        return result;
    }
    formatError(error) {
        if (!error) {
            return '';
        }
        // TODO: not sure what error detail we should pass back to users yet...
        // #DIV/0! Divide by zero error;
        // #N/A Indicates that a value is not available to a formula;
        // #NUM! Occurs when formula encounters an invalid number;
        switch (error) {
            case '#NAME?': // #NAME? Not recognized function name or variable name;
                return '#NAME? Unknown formula or cell';
            case '#ERROR!': // #ERROR! General error;
                return '#ERROR!';
            case '#VALUE!': // #VALUE! Occurs when one of formula arguments is of the wrong type.
                // We get this error whenever there isn't a value (which might be nothing in the cell or an invalid cell)
                return '#VALUE!';
            default:
                return error;
        }
    }
}
exports.FormulaService = FormulaService;
